import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import {
  OrderformOrderProductItem,
  OrderformProductItem,
  OrderformProductSettings,
  OrderformSettingsStateCustomForms,
} from '../ngrx/orderform.models';
import {
  getOrderformProductList,
  getOrderformProductSettings,
  getOrderformSettings,
  getOrderItems,
} from '../ngrx/orderform.selectors';
import { OrderformPartialState } from '../ngrx/orderform.reducer';
import { Store } from '@ngrx/store';
import { map, shareReplay } from 'rxjs/operators';

export interface OrderformCartProductItem extends OrderformProductItem {
  orderItem: OrderformOrderProductItem;
  customForms: OrderformSettingsStateCustomForms.RootObject[];
}

@Injectable({
  providedIn: 'root',
})
export class ProductListFascade {
  private _customForms$ = this._store.select(getOrderformSettings).pipe(
    map((settings) =>
      settings.custom_forms.filter((form) => form.show_on === 'product')
    ),
    shareReplay(1)
  );

  cartProductList$: Observable<OrderformCartProductItem[]> = combineLatest([
    this._store.select(getOrderformProductList),
    this._store.select(getOrderItems),
    this._customForms$,
  ]).pipe(
    map(([productList, orderItems, customForms]) => {
      return productList.map((product: OrderformProductItem) => {
        const dataToMap: OrderformCartProductItem = {
          ...product,
          orderItem: orderItems[product.product_id] || {},
          customForms: customForms.filter(
            (form) => form.show_on_products.indexOf(product.product_id) >= 0
          ),
        };
        return dataToMap;
      });
    })
  );
  settings$: Observable<OrderformProductSettings> = this._store.select(
    getOrderformProductSettings
  );

  constructor(private _store: Store<OrderformPartialState>) {}
}
